import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { registerIcons } from '@fluentui/style-utilities';
import SparkleImg from './sparkle.svg';

export const SparkleIcon = () => {
  const i18n = useContext(I18nContext);
  return (
    <img src={SparkleImg} alt={i18n.getString(_TL_('sparkle icon'))} />
  );
};

registerIcons({
  icons: {
    'sparkle-svg': <SparkleIcon />,
  },
});

export const SparkleImgSVGIcon = 'sparkle-svg';
export const SparkleImgIcon = SparkleImg;
